/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { some } from 'lodash';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import Loader from '../../../../Components/Utility/Loader/Loader';
import ConfirmationPopup from '../../../../Components/ModalPopup/ConfirmationPopup';
import DuplicateDeleteModal from '../../../../Components/ModalPopup/DuplicateDeleteModal';

import '../../SupplierSuggestion.css';
import { checkUpdatedData, shortenandHoverString } from '../../../../Components/helper';

import { getTestingLibraries, approveRejectSuggestion, setDuplicateCodeModal } from '../../store/SupplierSuggestion.action';

function TestingSuggestionCard({
  testLibraries,
  devOrderId,
  getTestingLibraries,
  approveRejectSuggestion,
  updateData,
  logedInUser,
  suggestionType,
  approveReject,
  sugestionObj,
  duplicateCodeModal,
  setDuplicateCodeModal,
  updatedSuggestionLibrary,
  approveRejectDisable,
  autoApproved,
}) {
  const [loader, setLoader] = useState(false);
  const dateFormat = 'DD-MM-YYYY, h:mm a';

  const [approveRejectComment, setApproveRejectComment] = useState();
  const [oldSuggestion, setOldSuggestion] = useState([]);
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [testLibrariesAsOriginal, setTestLibrariesAsOriginal] = useState([]);
  const [selectedIdTesting, setSelectedIdTesting] = useState([]);
  const [isSelectTestingAll, setIsSelectTestingAll] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);
  const [oldDataFound, setOldDataFound] = useState(suggestionType === 'new');
  const [disabledCheckBox, setDisabledCheckBox] = useState(false);
  const testingText = 'TESTING_SUGGESTION.APPROVED_BY';
  const pendingTestLib =
    testLibrariesAsOriginal && testLibrariesAsOriginal.length > 0 && testLibrariesAsOriginal.filter((item) => !['Approved', 'Deleted'].includes(item.status));

  const pendingTestLibCount = Array.isArray(pendingTestLib) && pendingTestLib.length;

  const suggestedOriginalData = Array.isArray(pendingTestLib) ? pendingTestLib?.filter((val) => some(oldSuggestion, { _id: val._id })) : [];

  const { t } = useTranslation('common');
  useEffect(() => {
    let totalData = [];
    totalData = suggestionType === 'new' ? pendingTestLib : suggestedOriginalData;

    if (totalData.length === selectedIdTesting.length && totalData.length > 0) {
      setIsSelectTestingAll(true);
    }
    if (selectedIdTesting.length > 0) {
      approveRejectDisable(false);
    } else {
      approveRejectDisable(true);
    }
  }, [selectedIdTesting]);

  useEffect(() => {
    setShowConfirmationPopup(approveReject?.status);
    setConfirmAction(approveReject?.action);
  }, [approveReject]);

  const handleCommentChange = (e) => {
    setApproveRejectComment(e.target.value);
  };

  const closeDuplicateDeleteModal = () => {
    setDuplicateCodeModal(false, null);
  };

  const checkUpdatedData1 = (newData, oldData) => {
    return newData !== oldData;
  };

  const fetchHighlight = () => {
    const obj = ['description', 'type', 'minPassRate', 'referenceCode', 'colour', 'additionalInformation'];
    const arr = [];
    testLibrariesAsOriginal.forEach((data) => {
      const obj1 = {
        id: data._id,
      };
      const oldData = Array.isArray(oldSuggestion) && oldSuggestion.filter((e) => e._id === data._id);
      for (const ob of obj) {
        if (ob === 'referenceCode') {
          obj1[ob] = checkUpdatedData1(data?.bomComponent?.referenceCode, oldData[0]?.bomComponent?.referenceCode);
        } else if (ob === 'colour') {
          obj1[ob] = checkUpdatedData1(data?.colour?.name, oldData[0]?.colour?.name);
        } else if (ob === 'type') {
          obj1[ob] = checkUpdatedData1(data?.type?.name, oldData[0]?.type?.name);
        } else {
          obj1[ob] = checkUpdatedData1(data[ob], oldData?.[0]?.[ob]);
        }
      }
      arr.push(obj1);
    });
    const finalArr = [];
    for (const val of arr) {
      const highlightedKeys = [];
      for (const val1 of obj) {
        if (val[val1]) {
          highlightedKeys.push(val1);
        }
      }
      if (highlightedKeys.length > 0) {
        finalArr.push({ id: val.id, highlightedKeys });
      }
    }

    console.log('finalArrfinalArr', finalArr);

    return finalArr;
  };

  const deleteById = async (e) => {
    sugestionObj.comment = approveRejectComment;
    sugestionObj.componentId = [...selectedIdTesting];
    sugestionObj.highlightedArr = fetchHighlight();
    if (confirmAction === 'Approved') {
      sugestionObj.type = suggestionType;
    }

    const response = await approveRejectSuggestion(confirmAction, sugestionObj, t); // API Action call

    if (response) {
      setShowConfirmationPopup(false);
      updateData();
    }
  };

  const getOldCardData = async () => {
    setLoader(true);
    const oldData = await getTestingLibraries(devOrderId[0]._id);
    setOldSuggestion(oldData);
    setOldDataFound(!oldDataFound);
    setLoader(false);
  };

  // all useEffect collection
  useEffect(() => {
    if (suggestionType !== 'new') {
      getOldCardData();
    }
  }, []);

  useEffect(() => {
    if (oldDataFound) {
      const newTestLibrary =
        testLibraries?.length > 0 &&
        testLibraries?.map((item, i) => {
          const oldData = Array.isArray(oldSuggestion) && oldSuggestion.filter((e) => e._id === item._id);

          if (oldData?.length === 0 && suggestionType !== 'new' && item.status !== 'Approved') {
            return {
              ...item,
              status: 'Deleted',
            };
          }
          return {
            ...item,
          };
        });
      setTestLibrariesAsOriginal(newTestLibrary);
    }
  }, [oldSuggestion, oldDataFound]); // eslint-disable-line

  useEffect(() => {
    updatedSuggestionLibrary(testLibrariesAsOriginal);
  }, [testLibrariesAsOriginal]); // eslint-disable-line

  const onSelectCheckBoxTesting = async (e, id) => {
    let selectedItems = [...selectedIdTesting];

    if (e.target.checked) {
      setSelectedIdTesting([
        ...selectedItems,
        {
          _id: id,
        },
      ]);
    } else {
      setIsSelectTestingAll(false);
      selectedItems = selectedItems.filter((item) => item._id !== id);
      setSelectedIdTesting([...selectedItems]);
    }
  };

  const handleSelectAllTesting = () => {
    if (isSelectTestingAll) {
      setSelectedIdTesting([]);
    } else {
      const selectedItems = [...selectedIdTesting];
      let totalItemList = [];
      totalItemList = suggestionType === 'new' ? pendingTestLib : suggestedOriginalData;

      for (const item of totalItemList) {
        const findItems = selectedItems.filter((val) => val._id === item._id);

        if (findItems.length === 0) {
          selectedItems.push({
            _id: item._id,
          });
        }
      }
      setSelectedIdTesting(selectedItems);
    }
    setIsSelectTestingAll(!isSelectTestingAll);
  };

  useEffect(() => {
    let newTestLibrary = [];
    let totalPending = 0;
    let totalRejected = 0;
    let totalApproved = 0;
    let totalDeleted = 0;

    const getOldData = async () => {
      const oldDataRes = await getTestingLibraries(devOrderId[0]._id);
      newTestLibrary = testLibraries.map((item, i) => {
        const oldData = Array.isArray(oldDataRes) && oldDataRes.filter((e) => e._id === item._id);

        if (oldData?.length === 0 && suggestionType !== 'new' && item.status !== 'Approved') {
          return {
            ...item,
            status: 'Deleted',
          };
        }
        return {
          ...item,
        };
      });

      if (newTestLibrary) {
        totalPending = newTestLibrary.filter((item) => item.status === 'Pending' || item.status === 'pending').length;

        totalRejected = newTestLibrary.filter((item) => item.status === 'Rejected').length;

        totalApproved = newTestLibrary.filter((item) => item.status === 'Approved').length;

        totalDeleted = newTestLibrary.filter((item) => item.status === 'Deleted').length;
      }

      if ((totalApproved > 0 || totalDeleted > 0 || !totalApproved || !totalDeleted) && totalPending === 1 && totalRejected === 0) {
        setDisabledCheckBox(true);
        const pendingId = testLibraries
          .filter((item) => item.status === 'Pending' || item.status === 'pending')
          .map((el) => ({
            _id: el._id,
          }));
        setIsSelectTestingAll(true);
        setSelectedIdTesting(pendingId);
      }

      if ((totalApproved > 0 || totalDeleted > 0 || !totalApproved || !totalDeleted) && totalPending === 0 && totalRejected === 1) {
        setDisabledCheckBox(true);
        const pendingId = testLibraries
          .filter((item) => item.status === 'Rejected')
          .map((el) => ({
            _id: el._id,
          }));
        setIsSelectTestingAll(true);
        setSelectedIdTesting(pendingId);
      }
    };

    getOldData();
  }, [testLibraries]); // eslint-disable-line

  const rendersStatusDisplay = (data) => {
    switch (data?.status) {
      case 'Approved':
        return (
          <>
            <span className="col-status right approved" /> {t('TESTING_SUGGESTION.APPROVED')}
            <div className="info-container">
              <span className="icon-info" />
              <div className="info-content suggestion-data">
                <p className="mb-1">
                  <b>{autoApproved ? t('TESTING_SUGGESTION.AUTO_APPROVED_BY') : t(testingText)}&nbsp;</b>
                  {data?.approvedRejectedBy?.firstName} {data?.approvedRejectedBy?.lastName}
                </p>
                <p className="mb-1">
                  <b>{t('TESTING_SUGGESTION.APPROVED_AT')}&nbsp;</b>
                  {moment(data?.approvedRejectedAt).format(dateFormat)}
                </p>
                <p className="mb-0">
                  <b>{t('TESTING_SUGGESTION.COMMENTS')}&nbsp;</b>
                  {data?.comment}
                </p>
              </div>
            </div>
          </>
        );

      case 'Rejected':
        return (
          <>
            <span className="col-status right rejected" />
            {t('TESTING_SUGGESTION.REJECTED')}
            <OverlayTrigger
              placement="bottom"
              trigger="hover"
              rootClose
              overlay={
                <Popover className="custom-popover modified-popover">
                  <Popover.Content>
                    <div>
                      <p className="mb-1">
                        <strong>{t('TESTING_SUGGESTION.REJECTED_BY')}&nbsp;</strong>
                        {data?.approvedRejectedBy?.firstName} {data?.approvedRejectedBy?.lastName}
                      </p>
                      <p className="mb-1">
                        <strong>{t('TESTING_SUGGESTION.REJECTED_AT')}&nbsp;</strong>
                        {moment(data.approvedRejectedAt).format(dateFormat)}
                      </p>
                      <p className="mb-0">
                        <strong>{t('TESTING_SUGGESTION.COMMENTS')}&nbsp;</strong>
                        {data?.comment}
                      </p>
                    </div>
                  </Popover.Content>
                </Popover>
              }
            >
              <i className="icon icon-Information f-20 ml-2" />
            </OverlayTrigger>
          </>
        );

      case 'Deleted':
        return (
          <>
            <span className="col-status right deleted" />
            {t('TESTING_SUGGESTION.ORIGINAL_DATA_EXIST')}
          </>
        );

      default:
        return (
          <>
            <span className="col-status right pending" />
            {t('TESTING_SUGGESTION.PENDING')}
          </>
        );
    }
  };

  return (
    <>
      <div>
        {loader ? (
          <Loader />
        ) : (
          <div className="table-responsive">
            {suggestionType && suggestionType === 'new' && (
              <table className="table common-custom-table">
                <thead>
                  <tr>
                    {logedInUser.role !== 'Supplier' && pendingTestLibCount > 0 && (
                      <th className="w-80px">
                        <div className="checkbox-label no-label margin-auto">
                          <input
                            type="checkbox"
                            onChange={handleSelectAllTesting}
                            name="check_all_testing"
                            id="check_all_testing"
                            checked={isSelectTestingAll || testLibraries.length === 1}
                            disabled={testLibraries.length === 1 || disabledCheckBox}
                          />
                          <label htmlFor="check_all_testing" className="chklabel">
                            <span />
                          </label>
                        </div>
                      </th>
                    )}

                    <th className="w-150px">{t('TESTING_SUGGESTION.NEW_SUGGESTION')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.TESTING_CODE')}</th>
                    <th className="w-200px">{t('TESTING_SUGGESTION.TESTING_DESCRIPTION')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.TEST_TYPE')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.MINIMUM_PASS_RATE')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.BOM_COMPONENT')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.COLOUR')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.ADDITIONAL_INFORMATION')}</th>
                    <th className="w-120px">{t('TESTING_SUGGESTION.STATUS')}</th>
                  </tr>
                </thead>
                <tbody>
                  {testLibraries?.map((data, i) => {
                    return (
                      <tr key={data?._id}>
                        {logedInUser?.role !== 'Supplier' && pendingTestLibCount > 0 && (
                          <td>
                            {data?.status !== 'Approved' && (
                              <div className="checkbox-label no-label margin-auto">
                                <input
                                  onChange={(e) => {
                                    onSelectCheckBoxTesting(e, data._id);
                                  }}
                                  name={`checks_pom_${i}`}
                                  id={`checks_pom_${i}`}
                                  type="checkbox"
                                  disabled={testLibraries.length === 1 || disabledCheckBox}
                                  checked={
                                    selectedIdTesting.filter((val) => val._id === data._id).length > 0 || !!(testLibraries.length === 1 || disabledCheckBox)
                                  }
                                />
                                <label htmlFor={`checks_pom_${i}`} className="chklabel">
                                  <span />
                                </label>
                              </div>
                            )}
                          </td>
                        )}
                        <td>{t('TESTING_SUGGESTION.SUGGESTION')}</td>
                        <td>{data?.code}</td>
                        <td>{shortenandHoverString(data?.description, 50)}</td>
                        <td>{data?.type?.name}</td>
                        <td>{data?.minPassRate}</td>
                        <td>{data?.bomComponent?.referenceCode}</td>
                        <td>{data?.colour?.name}</td>
                        <td>{shortenandHoverString(data?.additionalInformation, 40)}</td>
                        <td className="position-relative">{rendersStatusDisplay(data)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            )}

            {suggestionType && suggestionType !== 'new' && (
              <table className="table common-custom-table mb-0">
                <thead>
                  <tr>
                    {logedInUser.role !== 'Supplier' && pendingTestLibCount > 0 && (
                      <th className="w-80px">
                        <div className="checkbox-label no-label margin-auto">
                          <input
                            type="checkbox"
                            onChange={handleSelectAllTesting}
                            name="check_all_pom"
                            id="check_all_pom"
                            checked={isSelectTestingAll || testLibraries.length === 1}
                            disabled={testLibraries.length === 1 || disabledCheckBox}
                          />
                          <label htmlFor="check_all_pom" className="chklabel">
                            <span />
                          </label>
                        </div>
                      </th>
                    )}
                    <th className="w-150px">{t('TESTING_SUGGESTION.ORIGINAL_SUGGESTION')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.TESTING_CODE')}</th>
                    <th className="w-300px">{t('TESTING_SUGGESTION.TESTING_DESCRIPTION')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.TEST_TYPE')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.MINIMUM_PASS_RATE')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.BOM_COMPONENT')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.COLOUR')}</th>
                    <th className="w-150px">{t('TESTING_SUGGESTION.ADDITIONAL_INFORMATION')}</th>
                    <th className="w-120px">{t('TESTING_SUGGESTION.STATUS')}</th>
                  </tr>
                </thead>
                {testLibrariesAsOriginal.map((data, i) => {
                  const oldData = Array.isArray(oldSuggestion) && oldSuggestion.filter((e) => e._id === data._id);
                  return (
                    <tbody key={data?._id}>
                      {data.status === 'Approved' ? (
                        <tr>
                          {logedInUser.role !== 'Supplier' && pendingTestLibCount > 0 && <td aria-label="action" />}
                          <td>{t('TESTING_SUGGESTION.ORIGINAL')}</td>
                          <td>{data?.originalItem?.code}</td>
                          <td>{data?.originalItem?.description}</td>
                          <td>{data?.originalItem?.type?.name}</td>
                          <td>{data?.originalItem?.minPassRate}</td>
                          <td>{data?.originalItem?.bomComponent?.referenceCode}</td>
                          <td>{data?.originalItem?.colour?.name}</td>
                          <td>{data?.originalItem?.additionalInformation}</td>
                          <td aria-label="action" />
                        </tr>
                      ) : (
                        oldData.length > 0 && (
                          <tr>
                            {logedInUser.role !== 'Supplier' && pendingTestLibCount > 0 && <td aria-label="original" />}
                            <td>{t('TESTING_SUGGESTION.ORIGINAL')}</td>
                            <td>{shortenandHoverString(oldData[0]?.code, 20)}</td>
                            <td>{shortenandHoverString(oldData[0]?.description, 40)}</td>
                            <td>{shortenandHoverString(oldData[0]?.type?.name, 40)}</td>
                            <td>{shortenandHoverString(oldData[0].minPassRate, 30)}</td>
                            <td>{shortenandHoverString(oldData[0]?.bomComponent?.referenceCode, 40)}</td>
                            <td>{shortenandHoverString(oldData[0]?.colour?.name, 40)}</td>
                            <td>{shortenandHoverString(oldData[0]?.additionalInformation, 40)}</td>
                            <td aria-label="action" />
                          </tr>
                        )
                      )}
                      <tr>
                        {logedInUser.role !== 'Supplier' && pendingTestLibCount > 0 && (
                          <td>
                            {oldData?.length > 0 && data.status !== 'Approved' && (
                              <div className="checkbox-label no-label margin-auto">
                                <input
                                  onChange={(e) => {
                                    onSelectCheckBoxTesting(e, data._id);
                                  }}
                                  name={`checks_pom_${i}`}
                                  id={`checks_pom_${i}`}
                                  type="checkbox"
                                  checked={selectedIdTesting.some((val) => val._id === data._id) || testLibraries.length === 1}
                                  disabled={testLibraries.length === 1 || disabledCheckBox}
                                />
                                <label htmlFor={`checks_pom_${i}`} className="chklabel">
                                  <span />
                                </label>
                              </div>
                            )}
                          </td>
                        )}

                        <td>{t('TESTING_SUGGESTION.SUGGESTION')}</td>
                        <td>{shortenandHoverString(data?.code, 20)}</td>
                        {oldData?.length > 0 && data?.status !== 'Approved' ? (
                          checkUpdatedData(data?.description, oldData[0]?.description)
                        ) : (
                          <td>{shortenandHoverString(data.description, 40)}</td>
                        )}
                        {oldData?.length > 0 && data.status !== 'Approved' ? (
                          checkUpdatedData(data?.type?.name, oldData[0]?.type?.name)
                        ) : (
                          <td>{data?.type?.name}</td>
                        )}
                        {oldData?.length > 0 && data.status !== 'Approved' ? (
                          checkUpdatedData(data.minPassRate, oldData[0]?.minPassRate)
                        ) : (
                          <td>{data.minPassRate}</td>
                        )}
                        {oldData?.length > 0 && data.status !== 'Approved' ? (
                          checkUpdatedData(data?.bomComponent?.referenceCode, oldData[0]?.bomComponent?.referenceCode)
                        ) : (
                          <td>{data?.bomComponent?.referenceCode}</td>
                        )}
                        {oldData?.length > 0 && data.status !== 'Approved' ? (
                          checkUpdatedData(data?.colour?.name, oldData[0]?.colour?.name)
                        ) : (
                          <td>{data?.colour?.name}</td>
                        )}
                        {oldData?.length > 0 && data.status !== 'Approved' ? (
                          checkUpdatedData(data?.additionalInformation, oldData[0]?.additionalInformation)
                        ) : (
                          <td>{data?.additionalInformation}</td>
                        )}
                        <td className="position-relative">
                          {data?.status === 'Approved' ? (
                            <>
                              <span className="col-status right approved" />
                              {t('TESTING_SUGGESTION.APPROVED')}
                              <div className="info-container">
                                <span className="icon-info" />
                                <div className="info-content">
                                  <p className="mb-1">
                                    <b>{t('TESTING_SUGGESTION.APPROVED_BY')}&nbsp;</b>
                                    {data?.approvedRejectedBy?.firstName} {data?.approvedRejectedBy?.lastName}
                                  </p>
                                  <p className="mb-1">
                                    <b>{autoApproved ? t('TESTING_SUGGESTION.AUTO_APPROVED_BY') : t(testingText)}&nbsp;</b>
                                    {data?.approvedRejectedBy?.firstName} {data?.approvedRejectedBy?.lastName}
                                  </p>
                                  <p className="mb-1">
                                    <b>{t('TESTING_SUGGESTION.APPROVED_AT')}&nbsp;</b>
                                    {moment(data.approvedRejectedAt).format(dateFormat)}
                                  </p>
                                  <p className="mb-0">
                                    <b>{t('TESTING_SUGGESTION.COMMENT')}&nbsp;</b>
                                    {data?.comment}
                                  </p>
                                </div>
                              </div>
                            </>
                          ) : data.status === 'Rejected' ? (
                            <>
                              <span className="col-status right rejected" />
                              {t('TESTING_SUGGESTION.REJECTED')}
                              <div className="info-container">
                                <span className="icon-info" />
                                <div className="info-content">
                                  <p className="mb-1">
                                    <b> {t('TESTING_SUGGESTION.REJECTED_BY')}&nbsp;</b>
                                    {data?.approvedRejectedBy?.firstName} {data?.approvedRejectedBy?.lastName}
                                  </p>
                                  <p className="mb-1">
                                    <b>{t('TESTING_SUGGESTION.REJECTED_AT')}&nbsp;</b>
                                    {moment(data?.approvedRejectedAt).format(dateFormat)}
                                  </p>
                                  <p className="mb-0">
                                    <b>{t('TESTING_SUGGESTION.COMMENT')}&nbsp;</b>
                                    {data?.comment}
                                  </p>
                                </div>
                              </div>
                            </>
                          ) : data.status === 'Deleted' ? (
                            <>
                              <span className="col-status right deleted" />
                              {t('TESTING_SUGGESTION.ORIGINAL_DATA_DELETED')}
                            </>
                          ) : (
                            <>
                              <span className="col-status right pending" />
                              {t('TESTING_SUGGESTION.PENDING')}
                            </>
                          )}
                        </td>
                      </tr>
                    </tbody>
                  );
                })}
              </table>
            )}
          </div>
        )}
      </div>
      {showConfirmationPopup && (
        <ConfirmationPopup
          onOpen={showConfirmationPopup}
          onConfirm={deleteById}
          loading={false}
          title={
            confirmAction === 'Approved'
              ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_APPROVE')
              : confirmAction === 'Rejected'
              ? t('SUPPLIER_SUGGESTION.CONFIRM.TITLE_REJECT')
              : ''
          }
          message={
            confirmAction === 'Approved'
              ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_APPROVE')
              : confirmAction === 'Rejected'
              ? t('SUPPLIER_SUGGESTION.CONFIRM.DELETE_MESSAGE_REJECT')
              : ''
          }
          toggle={() => setShowConfirmationPopup(!showConfirmationPopup)}
          isCommentOn
          commentText={handleCommentChange}
        />
      )}

      {duplicateCodeModal.isOpen && (
        <DuplicateDeleteModal
          onOpen={duplicateCodeModal.isOpen}
          title={t('TESTING_SUGGESTION.TITLE')}
          toggle={() => closeDuplicateDeleteModal()}
          codeItem={duplicateCodeModal?.code}
        />
      )}
    </>
  );
}

const mapStateToProps = ({ UserDetails, SupplierSuggestion }) => {
  const { TestingLibraries, duplicateCodeModal } = SupplierSuggestion;
  const { userInfo } = UserDetails;
  return {
    logedInUser: userInfo,
    oldCardData: TestingLibraries,
    duplicateCodeModal,
  };
};

const mapStateToDispatch = {
  getTestingLibraries,
  approveRejectSuggestion,
  setDuplicateCodeModal,
};

export default connect(mapStateToProps, mapStateToDispatch)(TestingSuggestionCard);
